var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.position.show),expression:"position.show"}],staticClass:"FlipNumber"},_vm._l((_vm.option.number),function(n,index){return _c('Flipper',{key:n,ref:'flip' + index,refInFor:true,attrs:{"styleConfig":_vm.option.style}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }